<div [formGroup]="form" class="flex-wrap">

  <mat-form-field redispatchProvideReadonly>
    <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_WECHSELRICHTERLEISTUNG_KUMULIERT"
    [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
    <mat-label>kumulierte Wechselrichterleistung [kW]</mat-label>
    <input formControlName="wechselrichterleistungKumuliert"
      data-qa="wechselrichterleistungKumuliert"
      [redispatchDisableControl]="disabled || readonly"
      type="number"
      matInput
      name="solar_wechselrichterleistungKumuliert"/>
    @if (f.wechselrichterleistungKumuliert.hasError('required')) {
      <mat-error>
        Bitte geben Sie eine kumulierte Wechselrichterleistung [kW] ein.
      </mat-error>
    }
    @if (f.wechselrichterleistungKumuliert.hasError('max')) {
      <mat-error>
        Maximal 999999,999.
      </mat-error>
    }
    @if (f.wechselrichterleistungKumuliert.hasError('pattern') && !f.wechselrichterleistungKumuliert.hasError('max')) {
      <mat-error
        >
        Maximal 3 Nachkommastellen.
      </mat-error>
    }
  </mat-form-field>

  <mat-form-field redispatchProvideReadonly>
    <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AUSRICHTUNG_PV_MODULE"
    [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
    <mat-label>Ausrichtung PV-Module [Grad]</mat-label>
    <input formControlName="ausrichtungPvModuleGrad"
      data-qa="ausrichtungPvModuleGrad"
      type="number"
      [redispatchDisableControl]="disabled || readonly"
      [required]="isSpitzOrSpitzLight"
      matInput
      name="solar_ausrichtungPvModuleGrad"/>
    @if (!disabled && isSpitzOrSpitzLight) {
      <mat-hint>{{ spitzOrSpitzLightHint }}</mat-hint>
    }
    @if (f.ausrichtungPvModuleGrad.hasError('required')) {
      <mat-error>
        Bitte geben Sie die Ausrichtung des PV-Module in Grad ein
      </mat-error>
    }
    @if (f.ausrichtungPvModuleGrad.hasError('min') || f.ausrichtungPvModuleGrad.hasError('max')) {
      <mat-error>
        Bitte geben Sie eine Ausrichtung zwischen {{ AUSRICHTUNG_MIN }} und {{ AUSRICHTUNG_MAX }} ein
      </mat-error>
    }
    @if (f.ausrichtungPvModuleGrad.hasError('pattern')) {
      <mat-error>
        Es sind nur natürliche Zahlen erlaubt
      </mat-error>
    }
  </mat-form-field>

  <mat-form-field redispatchProvideReadonly>
    <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_NEIGUNGSWINKEL_PV_MODULE"
    [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
    <mat-label>Neigungswinkel PV-Module [Grad]</mat-label>
    <input formControlName="neigungswinkelPvModuleGrad"
      data-qa="neigungswinkelPvModuleGrad"
      type="number"
      [redispatchDisableControl]="disabled || readonly"
      [required]="isSpitzOrSpitzLight"
      matInput
      name="solar_neigungswinkelPvModuleGrad"/>
    @if (!disabled && isSpitzOrSpitzLight) {
      <mat-hint>{{ spitzOrSpitzLightHint }}</mat-hint>
    }
    @if (f.neigungswinkelPvModuleGrad.hasError('required')) {
      <mat-error>
        Bitte geben Sie den Neigungswinkel des PV-Module in Grad ein
      </mat-error>
    }
    @if (f.neigungswinkelPvModuleGrad.hasError('min') || f.neigungswinkelPvModuleGrad.hasError('max')) {
      <mat-error>
        Bitte geben Sie einen Neigungswinkel zwischen {{ NEIGUNGSWINKEL_MIN }} und {{ NEIGUNGSWINKEL_MAX }} ein
      </mat-error>
    }
    @if (f.neigungswinkelPvModuleGrad.hasError('pattern')) {
      <mat-error>
        Es sind nur natürliche Zahlen erlaubt
      </mat-error>
    }
  </mat-form-field>

  <mat-form-field redispatchProvideReadonly>
    <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_ABSENKUNG_70"
    [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
    <mat-label>Absenkung 70%</mat-label>
    <mat-select formControlName="absenkung70"
      data-qa="absenkung70"
      name="solar_absenkung70">
      @for (item of SolarAbsenkung70Items; track item.key) {
        <mat-option
          [value]="item.key">{{ item.description }}
        </mat-option>
      }
    </mat-select>
    @if (!disabled) {
      <mat-hint>{{ absenkung70Hint }}</mat-hint>
    }
  </mat-form-field>

</div>
